module.exports = __webpack_public_path__ + "img/6.8c78ae70.jpg";